<template>
  <CDropdown 
    placement="bottom-end"
    :caret="false"
    in-nav
    class="c-header-nav-item d-md-down-none mx-2"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cil-bell"/>
        <CBadge shape="pill" color="danger">{{configureNumber()}}</CBadge>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader 
      tag="div" 
      class="text-center bg-light"
    >
      <strong>You have {{configureNumber()}} notifications</strong>
      <div style="width:100%;padding-top:5px;">
        <CButton size="sm" color="danger" @click="removeRead()">Remove Read</CButton>
        <CButton size="sm" color="danger" style="margin-left:5px;" @click="removeAll()">Remove All</CButton>
      </div>
    </CDropdownHeader>
    <div style="width:300px;max-height:400px;overflow-y:scroll;" v-if="$store.state.notifications">
      <!-- <CDropdownItem style="width:100%;"> -->
        <div v-for="val in $store.state.notifications" class="item" :class="val.read_at ? ' read': ''" @click="goTo(val)">
          <CIcon name="cil-user-follow" class="text-success"/> Order# {{val.order_id}} - {{val.text}}
        </div>
      <!-- </CDropdownItem> -->
    </div>
    <!-- <CDropdownItem>
      <CIcon name="cil-user-unfollow" class="text-danger"/> User deleted
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-chart-pie" class="text-info"/> Sales report is ready
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-basket" class="text-primary"/> New client
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-speedometer" class="text-warning"/> Server overloaded
      </CDropdownItem>
    <CDropdownHeader tag="div" class="text-center bg-light">
      <strong>Server</strong>
    </CDropdownHeader>
    <CDropdownItem class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>CPU Usage</b></small>
      </div>
      <CProgress class="progress-xs" color="info" :value="25"/>
      <small class="text-muted">348 Processes. 1/4 Cores.</small>
    </CDropdownItem>
    <CDropdownItem class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>Memory Usage</b></small>
      </div>
      <CProgress class="progress-xs" color="warning" :value="70"/>
      <small class="text-muted">11444GB/16384MB</small>
    </CDropdownItem>
    <CDropdownItem class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>SSD 1 Usage</b></small>
      </div>
      <CProgress class="progress-xs" color="danger" :value="90"/>
      <small class="text-muted">243GB/256GB</small>
    </CDropdownItem> -->
  </CDropdown>
</template>
<script>
var methods = {}

methods.getNotifications = function () {
  axios.get(this.$apiAdress + '/api/notifications/get?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    // this.data = response.data
    this.$store.commit('setNotifications', response.data)
  }).catch(e => {
    console.log(e)
  })
}

methods.removeRead = function () {
  axios.post(this.$apiAdress + '/api/notifications/removeRead?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    // this.data = response.data
    this.$store.commit('setNotifications', response.data)
  })
}
methods.removeAll = function () {
  axios.post(this.$apiAdress + '/api/notifications/removeAll?token=' + localStorage.getItem('api_token')).then(response => {
    // this.data = response.data
    this.$store.commit('setNotifications', response.data)
  })
}

methods.configureNumber = function () {
  var t = 0
  if (this.$store.state.notifications && this.$store.state.notifications.length) {
    this.$store.state.notifications.forEach(function (val) {
      if (!val.read_at) {
        t++
      }
    })
  }
  return t
}

methods.goTo = function (val) {
  val.read_at = true
  this.$forceUpdate()
  // this.$router.push('/order/' + val.order_id)
  if (val.type !== 'saved_order_favor') {
    if (val.order_group_id && val.order_id) {
      this.$router.push('/order/' + val.order_id + '/' + val.order_group_id)
    } else if (val.order_id) {
      this.$router.push('/order/' + val.order_id)
    }
  } else {
    this.$router.push('/create_order/' + val.order_id + '/saved')
  }
}

export default {
  name: 'TheHeaderDropdownNotif',
  data () {
    return { 
      itemsCount: 5,
      data: []
    }
  },
  methods: methods,
  mounted: function () {
    this.getNotifications()
  }
}
</script>

<style scoped lang="scss">
  .c-icon {
    margin-right: 0.3rem;
  }
  .item {
    width:100%;float:left;
    padding:5px;
    border-bottom:1px solid gray;

    &:hover {
      background-color: #e0e0e0;
      cursor: pointer;
    };
  }

  .read {
    background-color: #e0e0e0;

    &:hover {
      background-color: #cccccc;
    }
  }
</style>
